import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { CarItemCard } from '@components/Home/CarItemCard';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { t } from '@lingui/core/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiBasicCard, NoddiEmptyPage, TablePagination } from 'noddi-ui-web';
import { useAuthContext } from 'noddi-web';
import { useCustomerAppPagination } from '../../../../hooks/useCustomerAppPagination';
import { useCurrentBrand } from '../../../../stores/BrandStore/brandStore';
import { getCommonTranslations } from '../../../../utils/commonTranslations';

export const CarsListPage = () => {
  const { pagination, setPagination } = useCustomerAppPagination();

  const { getCurrentUserGroupId } = useAuthContext();
  const userGroupId = getCurrentUserGroupId();
  const { currentBrand } = useCurrentBrand();

  const {
    isPending,
    data: cars,
    error,
    isFetching
  } = noddiAsync.useGet({
    type: URLKeys.getPaginatedFleetViewCars,
    input: {
      userGroupIds: [userGroupId!],
      brandDomains: [currentBrand],
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex
    }
  });

  if (isPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (error) {
    return <ApiErrorPageWithTrans error={error} />;
  }

  const handlePaginationChange = ({ pageIndex, pageSize }: { pageIndex: number; pageSize: number }) => {
    setPagination({ pageIndex, pageSize, search: pagination.search });
  };

  if (cars.count === 0) {
    return (
      <ContentWrapperCustomerApp title={t`My cars`}>
        <NoddiEmptyPage
          title={t`No cars found`}
          message={t`You don't have any cars registered yet. Add a car to get started.`}
        />
      </ContentWrapperCustomerApp>
    );
  }

  return (
    <ContentWrapperCustomerApp title={t`My cars`} showNewBookingButton>
      <div className='flex w-full flex-col gap-4'>
        {cars.results.map((car) => (
          <CarItemCard key={car.id} car={car} />
        ))}
        <NoddiBasicCard className='p-4'>
          <TablePagination
            loading={isFetching}
            pagination={pagination}
            onChange={handlePaginationChange}
            totalCount={cars.count}
            translations={getCommonTranslations().table}
          />
        </NoddiBasicCard>
      </div>
    </ContentWrapperCustomerApp>
  );
};
